import { render, staticRenderFns } from "./FloatBtns.vue?vue&type=template&id=64eb9a19&scoped=true"
import script from "./FloatBtns.vue?vue&type=script&lang=js"
export * from "./FloatBtns.vue?vue&type=script&lang=js"
import style0 from "./FloatBtns.vue?vue&type=style&index=0&id=64eb9a19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb9a19",
  null
  
)

export default component.exports